var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-query-left-nav"},[_c('PtMasterNav',{attrs:{"service":_vm.service}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }